<template>
  <div>
    <span>your secret:</span>
    <p style="white-space: pre-line;">{{ message }}</p>
    <br>
    <div>
      <textarea v-model="message" cols="50" rows="6" placeholder="type your secret here..."></textarea>
    </div>
    <br>
    <div>
      <input type="checkbox" id="pwoption" value="true" v-model="pwchecked">
      <label for="pwoption">add password (optional):   </label>
      <span v-show=pwchecked>
      <input v-model="password" placeholder="password (optional)">
      </span>
    </div>
      <br>
    <div>save this secret - for sure it's save!</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: "",
      pwchecked: ""
    };
  }
};
</script>

<style>
</style>
